import * as React from "react";
import { useDispatch, useSelector } from "react-redux";
import GridContainer from "@frameworks/web/components/generic/CommonUI/GridContainer";
import StreamingHeader from "./RevampHeader/StreamingHeader";
import NavHeader from "./RevampHeader/NavHeader";
const HeaderDesk = () => {
    const dispatch = useDispatch();
    const { headerBG_Properties, showHeader, scrollHeader } = useSelector((state) => state.header);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: `position-sticky-mainhead  ${scrollHeader ? "" : "position-sticky"}`, style: headerBG_Properties },
            React.createElement(GridContainer, { parentClass: "px-0 headTop" },
                React.createElement("div", { 
                    // style={{ display: showHeader ? "fade-in" : "fade-out" }}
                    className: showHeader ? "d-block" : "d-none" },
                    React.createElement("div", { className: "main-custom-stock d-flex" },
                        React.createElement(StreamingHeader, null)),
                    React.createElement(NavHeader, null))))));
};
export default HeaderDesk;
